// Site footer with the legal documents and the Grievance Officer — on every public page and
// inside the dashboard (the Intermediary Rules require them to be published prominently).
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Stack, Link, Typography } from '@mui/material';
import { useCompanyDetails } from '../utils/companyDetails';

const LINKS = [
  ['/legal/terms', 'Terms & Conditions'],
  ['/legal/privacy', 'Privacy Policy'],
  ['/legal/refunds', 'Refunds & Cancellations'],
  ['/legal/vendor-terms', 'Vendor Agreement'],
  ['/legal/notices', 'Legal Notices'],
  ['/legal/grievance', 'Grievance Officer / Raise a complaint'],
];

// signedIn: also links the user's own My Data & Privacy page
export default function LegalFooter({ dark = false, sx, signedIn = false }) {
  const company = useCompanyDetails();
  const color = dark ? 'rgba(255,255,255,0.85)' : 'text.secondary';
  return (
    <Box component="footer" sx={{ py: 2, px: 2, textAlign: 'center', '@media print': { display: 'none' }, ...sx }}>
      <Stack direction="row" spacing={2} justifyContent="center" flexWrap="wrap" useFlexGap mb={0.5}>
        {[...LINKS, ...(signedIn ? [['/dashboard/privacy', 'My data & privacy']] : [])].map(([to, label]) => (
          <Link key={label} component={RouterLink} to={to} variant="caption" underline="hover" sx={{ color }}>{label}</Link>
        ))}
      </Stack>
      <Typography variant="caption" sx={{ color }}>
        © {new Date().getFullYear()} {company?.name || company?.brandName || ''}. For matrimonial purposes only — not a dating site.
      </Typography>
    </Box>
  );
}
